import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'
import errorMapper from '@returnmates/client-core/src/utils/errorMapper'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo, useCallback } from 'react'
import { Field } from 'react-final-form'
import { useDispatch } from 'react-redux'

import UploadLabelField from '../../UploadLabelField'
import useStyles from '../styles'

const PARTNER_BUCKET = 'returnmates'
const PARTNER_REGION = 'us-east-2'
const PARTNER_FOLDER = 'partners'
const acceptUploadTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg']

function TrackingPageSettings() {
  const dispatch = useDispatch()
  const classes = useStyles({})

  const setError = useCallback(
    error => {
      if (error) {
        dispatch(
          actions.addSnackBar.request({
            type: SnackBarStatuses.ERROR,
            message: errorMapper(error),
          }),
        )
      }
    },
    [dispatch],
  )

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Tracking Page Logo</p>
        <Field name="tpLogo">
          {({ meta, input }) => (
            <UploadLabelField
              labelUrl={input}
              setError={setError}
              error={meta.error}
              bucket={PARTNER_BUCKET}
              region={PARTNER_REGION}
              folder={PARTNER_FOLDER}
              acceptUploadTypes={acceptUploadTypes}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Tracking Page Banner</p>
        <Field name="tpBanner">
          {({ input, meta }) => (
            <Input
              placeholder="AB19F0"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
              pattern="CCCCCC"
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(TrackingPageSettings)
